import moment from "moment";
import AuthService from "Lib/API/Auth";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import EvevntService from "Lib/API/Events";
import { PulseLoader } from "react-spinners";
import { eventsSlice } from "services/api/events";
import React, { useEffect, useState } from "react";
import { setLocalizationMoment } from "helper/dateFormat";
import {
  useParams,
   useLocation
} from "react-router-dom";
import {
  getAccessTokenSilently,
  getAuthenticated,
  setLocalStorageItem,
} from "utils/functions";
// direct link
import { Spinner } from "./Theme";
import { EventInfo } from "./EventComponents/EventInfo/EventInfo";
import { setLogoImage } from "services/api/organization";

export const Event = () => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const params = useParams();
  const [isLoading, setIsLoding] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const token = queryParams.get("token");
  const refreshToken = queryParams.get("refresh_token");

  const source = queryParams.get("source");

  useEffect(() => {
    if (token && refreshToken) {
      const userAuthData = {
        token: token,
        refreshToken: refreshToken,
      };
      setLocalStorageItem("userAuthData", userAuthData);
         if (source === "app") {
        sessionStorage.setItem("entrySource", "app");
      } else {
        sessionStorage.setItem("entrySource", "web");
      }

          getUserData(token)

      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [token, refreshToken,source]);

    const entrySource = sessionStorage.getItem("entrySource");
 const getUserData= async(token)=>{
      // const token = await getAccessTokenSilently();
                    AuthService.getUserExist(token)
                      .then((res) => {
                        localStorage.setItem(
                          "paymentMethod",
                          JSON.stringify(res?.user?.paymentMethodCreditCard)
                        );
                        localStorage.setItem(
                          "checkUser",
                          JSON.stringify(res?.exists)
                        );
                        localStorage.setItem(
                          "accountID",
                          res?.user?.permissions?.linked_account?._id
                        );
                        localStorage.setItem(
                          "accountName",
                          res?.user?.permissions?.linked_account?.family_name
                        );
                        localStorage.setItem(
                          "accountInfo",
                          JSON.stringify({
                            firstName:
                              res?.user?.permissions?.linked_contact?.first_name,
                            lastName:
                              res?.user?.permissions?.linked_contact?.last_name,
                            primary_email_address:
                              res?.user?.permissions?.linked_contact?.email_address,
                            emergency_contact_name:
                              res?.user?.permissions?.linked_contact
                                ?.emergency_contact_name,
                            emergency_contact_number:
                              res?.user?.permissions?.linked_contact
                                ?.emergency_contact_number,
                            profileImage:
                              res?.user?.permissions?.linked_contact?.profile_img,
                          })
                        );
                        localStorage.setItem(
                          "organization",
                          JSON.stringify(res?.user?.permissions?.organization)
                        );
                        localStorage.setItem(
                          "memberSetting",
                          JSON.stringify(
                            res?.user?.permissions?.organization?.memberSetting ||
                              {}
                          )
                        );
                        localStorage.setItem(
                          "memberPortalDirectory",
                          JSON.stringify(
                            res?.user?.permissions?.organization
                              ?.memberPortalDirectory || false
                          )
                        );
                        localStorage.setItem(
                          "linkedAccount",
                          JSON.stringify(res?.user?.permissions?.linked_account)
                        );
                        localStorage.setItem("hasPayment", res?.user?.hasPayment);
                        localStorage.setItem(
                          "logoImg",
                          res?.user?.permissions?.organization?.logoImg
                        );
                        localStorage.setItem(
                          "orgId",
                          res?.user?.permissions?.organization?._id
                        );
                        res?.user?.permissions?.organization?.logoImg &&
                          dispatch(
                            setLogoImage(
                              res?.user?.permissions?.organization?.logoImg
                            )
                          );
                        localStorage.setItem(
                          "orgName",
                          res?.user?.permissions?.organization?.orgName
                        );
                        document.title = `${res?.user?.permissions?.organization?.orgName}`;
                      })
                      
  }

  const getEventById = async () => {
    const subDomain = window.location.hostname.split(".")[0];
    const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
    setIsLoding(true);
    try {
      const auth = await AuthService.generateToken(hostName);
      const token = isAuth ? await getAccessTokenSilently() : auth?.token;
      localStorage.setItem("eventToken", auth?.token);
       dispatch(setLogoImage(auth?.logoImg));
      localStorage.setItem("logoImgEvent", auth?.logoImg);
      localStorage.setItem("eventOrgId", auth?._id);
      localStorage.setItem("email", auth?.contactInfo?.email);
      localStorage.setItem("phone", auth?.contactInfo?.phone);
      localStorage.setItem("orgName", auth?.orgName);
      localStorage.setItem("country", JSON.stringify(auth?.country || {}));
      localStorage.setItem("shul_website", auth?.shul_website || "");
      localStorage.setItem("memberPortal", auth?.memberPortal || false);
      localStorage.setItem(
        "allowInstallments",
        auth?.allowInstallments || false
      );

      setLocalizationMoment(auth?.country?.local || "en");
      document.title = `${auth?.orgName}`;
      localStorage.setItem(
        "paymentMethodEvents",
        JSON.stringify(auth?.paymentMethodCreditCard)
      );
      localStorage.setItem(
        "achPaymentMethodEvents",
        JSON.stringify(auth?.paymentMethodAch)
      );

      await EvevntService.getEventById(token, params?.id).then((res) => {
        dispatch(eventsSlice.actions.setEventData(res?.result));
        if (res?.result?.eventPricing?.prices.length > 0) {
          // Filter data to save products that have an optinal type
          const products = res?.result?.eventPricing?.prices?.filter((item) => {
            if (item?.type === "optional" || item?.type === "openAmount") {
              return item;
            }
          });
          const varients = [];
          let varientCapacity = 0;
          // Add New Fiels to variantInfo to manage products counter
          const productRest = products?.map((val) => {
            if (val?.variant) {
              const variantInfodata =
                val?.variantInfo &&
                Object.keys(val?.variantInfo).map((key) => ({
                  [key]: {
                    ...val.variantInfo[key],
                    counterValue: 0,
                    selectedValue: "",
                  },
                }));
              const variantsInfo =
                val?.variantInfo &&
                Object.keys(val?.variantInfo).map((key) => {
                  if (val.variantInfo[key]?.infiniteQuantity) {
                    varientCapacity = Infinity;
                  } else {
                    varientCapacity += Number(val.variantInfo[key]?.quantity) || 0;
                  }
                  return {
                    option: key,
                    counterValue: 0,
                    selectedValue: "",
                    ...val.variantInfo[key],
                    quantity: Number(val.variantInfo[key]?.quantity) || 0,
                    minimumOpenAmount: val.variantInfo[key]?.minimumOpenAmount || val.variantInfo[key]?.amount || 0,
                  };
                });
              varients.push({
                variantsInfo: variantsInfo,
                varientCapacity: varientCapacity === Infinity || isNaN(varientCapacity)
                  ? "noLimit"
                  : varientCapacity,
                numberOfDrops: 0,
                varientTitle: val.title,
                id: val._id,
              });
              varientCapacity = 0;
              return {
                ...val,
                variantInfo: variantsInfo,
                counter: 0,
                dropdowns: [],
              };
            } else {
              varients.push({
                numberOfDrops: 0,
                quantity: 0,
                varientCapacity: !val.infiniteQuantity
                  ? Number(val.quantity)
                  : "noLimit",
                counterValue: 0,
                variantsInfo: [],
                varientTitle: val.title,
                id: val._id,
                type: val.type,
                amount: val.price || val.amount || 0,
              });
              return { ...val, counter: 0, dropdowns: [] };
            }
          });
          const allProducts = [...productRest];

          localStorage.setItem(
            "originVarients",
            JSON.stringify({ ...varients })
          );
          dispatch(eventsSlice.actions.setVarients({ ...varients }));
          dispatch(eventsSlice.actions.resetAction([]));
          dispatch(eventsSlice.actions.setProducts(allProducts));
        }
        const startDateDiff = moment().diff(
          moment(res?.result?.eventStartDate),
          "minutes"
        );
        const endDateDiff = moment().diff(
          res?.result?.eventEndDate
            ? moment(res?.result?.eventEndDate)
            : moment(),
          "minutes"
        );
        if (!res?.result?.allowNonMembers && !token) {
          enqueueSnackbar("This event is available exclusively for members", {
            variant: "error",
          });
        } else if (endDateDiff > 0) {
          enqueueSnackbar(
            "This event is no longer available due to its expiration date",
            {
              variant: "error",
            }
          );
        } else if (startDateDiff < 0) {
          enqueueSnackbar(
            `This event has not yet begun. Please check back closer to the start date for access`,
            {
              variant: "error",
            }
          );
        }
        setIsLoding(false);
      });
    } catch (error) {
      setIsLoding(false);
      throw error;
    }
  };
  useEffect(() => {
    localStorage.removeItem("redirectUrl");
    dispatch(eventsSlice.actions.setProducts([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getEventById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);
  return (
    <>
      {isLoading ? (
        <Spinner>
          <PulseLoader color={"#2555EF"} size={"30px"} />
        </Spinner>
      ) : (
        <EventInfo />
      )}
    </>
  );
};
